import React from "react";
import {Col, ColorPicker, Row, Space} from "antd";
import {ColumnProps} from "antd/es/table";
import Moment from "moment";
const columns: ColumnProps<any>[] = [
  {
    key: "2",
    title: "Mã loại thuốc",
    dataIndex: "id",
    align: "left",
  },
  {
    key: "3",
    title: "Tên loại thuốc",
    dataIndex: "name",
    align: "left",
  },
  {
    key: "4",
    title: "Mô tả",
    dataIndex: "description",
    align: "left",
  },
  {
    key: "5",
    title: "Người tạo",
    dataIndex: "createBy",
    align: "left",
  },

  {key: "7", title: "Thao tác", dataIndex: "action", width: 80},
];
export {columns};
